import styled, { css } from 'styled-components';
import {} from './index.js';
import { getTypographyStyles, SYS_BORDER_RADIUS_MAX, SYS_SIZE_FIXED_1200, SYS_SIZE_FIXED_2400, SYS_SIZE_FIXED_600, SEM_TYPOGRAPHY_UI_SM_LABEL, SEM_TYPOGRAPHY_UI_MD_LABEL, getMargins, CMP_OPACITY_UI_AVATAR_IMAGE_DISABLED, CMP_OPACITY_UI_AVATAR_IMAGE_DEFAULT, SYS_BORDER_WIDTH_100, CMP_TYPOGRAPHY_UI_AVATAR_XS_LABEL, CMP_TYPOGRAPHY_UI_AVATAR_2_XS_LABEL, SYS_SIZE_FIXED_900 } from '@oneaudi/unified-web-alpha-common';
export const StyledAvatar = styled.button `
  margin: ${(props) => getMargins(props.margin)};
  padding: 0;
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  border-radius: ${SYS_BORDER_RADIUS_MAX};
  cursor: pointer;

  ${(props) => {
    const state = props.$selected ? 'selected' : 'idle';
    if (props.variant === 'logged-in') {
        const { surface, foreground } = props.theme.cmp.color.ui.avatar.loggedIn;
        if (props.image) {
            return css `
          border: none;
          position: relative;

          &::after {
            // TODO: token missing;
            transition-property: background-color, border-color;
            transition-duration: 250ms;
            transition-timing-function: ease;
            content: '';
            position: absolute;
            background-color: ${props.theme.cmp.color.ui.avatar.loggedIn.image
                .surface.imageStateLayer.fill[props.$selected ? 'selected' : 'idle']};
            border-width: ${SYS_BORDER_WIDTH_100};
            border-style: solid;
            border-radius: ${SYS_BORDER_RADIUS_MAX};
            border-color: ${props.theme.cmp.color.ui.avatar.loggedIn.image
                .surface.stroke[props.$selected ? 'selected' : 'idle']};
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            opacity: ${CMP_OPACITY_UI_AVATAR_IMAGE_DEFAULT};
          }

          &:hover:not(:disabled),
          &:active:not(:disabled) {
            &::after {
              background-color: ${(props) => props.theme.cmp.color.ui.avatar.loggedIn.image.surface
                .imageStateLayer.fill.interactive};
              border-color: ${props.theme.cmp.color.ui.avatar.loggedIn.image
                .surface.stroke.interactive};
            }
          }

          // TODO: needed?
          &:disabled {
            &::after {
              opacity: ${CMP_OPACITY_UI_AVATAR_IMAGE_DISABLED};
              background-color: ${(props) => props.theme.cmp.color.ui.avatar.loggedIn.image.surface
                .imageStateLayer.fill.disabled};
              border-color: ${props.theme.cmp.color.ui.avatar.loggedIn.image
                .surface.stroke.disabled};
            }
          }
        `;
        }
        return css `
        border-width: ${SYS_BORDER_WIDTH_100};
        border-style: solid;
        background-color: ${surface.fill[state]};
        color: ${props.icon ? foreground.icons[state] : foreground.text[state]};
        border-color: ${surface.stroke[state]};
        // TODO: token missing;
        transition-duration: 250ms;
        transition-timing-function: ease;
        transition-property: color, border-color, background-color;

        ${props.as === 'button' &&
            css `
          &:hover:not(:disabled),
          &:active:not(:disabled) {
            color: ${props.icon
                ? foreground.icons.interactive
                : foreground.text.interactive};
            border-color: ${surface.stroke.interactive};
            background-color: ${surface.fill.interactive};
          }

          &:disabled {
            border-color: ${surface.stroke.disabled};
            background-color: ${surface.fill.disabled};
            color: ${props.icon
                ? foreground.icons.disabled
                : foreground.text.disabled};
          }
        `}
      `;
    }
    if (props.variant === 'logged-out') {
        const { surface, foreground } = props.theme.cmp.color.ui.avatar.loggedOut;
        return css `
        border-width: ${SYS_BORDER_WIDTH_100};
        border-style: solid;
        border-color: ${surface.stroke[state]};
        background-color: ${surface.fill[state]};
        color: ${foreground.icons[state]};
        // TODO: token missing;
        transition-duration: 250ms;
        transition-timing-function: ease;
        transition-property: color, border-color, background-color;

        ${props.as === 'button' &&
            css `
          &:hover:not(:disabled),
          &:active:not(:disabled) {
            color: ${foreground.icons.interactive};
            border-color: ${surface.stroke.interactive};
            background-color: ${surface.fill.interactive};
          }

          &:disabled {
            color: ${foreground.icons.disabled};
            border-color: ${surface.stroke.disabled};
            background-color: ${surface.fill.disabled};
          }
        `}
      `;
    }
    return;
}};

  ${(props) => {
    if (props.size === '2xs') {
        return css `
        height: ${SYS_SIZE_FIXED_600};
        width: ${SYS_SIZE_FIXED_600};
        ${getTypographyStyles(CMP_TYPOGRAPHY_UI_AVATAR_2_XS_LABEL)}
      `;
    }
    if (props.size === 'xs') {
        return css `
        height: ${SYS_SIZE_FIXED_900};
        width: ${SYS_SIZE_FIXED_900};
        ${getTypographyStyles(CMP_TYPOGRAPHY_UI_AVATAR_XS_LABEL)}
      `;
    }
    if (props.size === 'sm') {
        return css `
        height: ${SYS_SIZE_FIXED_1200};
        width: ${SYS_SIZE_FIXED_1200};
        ${getTypographyStyles(SEM_TYPOGRAPHY_UI_SM_LABEL)}
      `;
    }
    return css `
      height: ${SYS_SIZE_FIXED_2400};
      width: ${SYS_SIZE_FIXED_2400};
      ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_LABEL)}
    `;
}}

  &:disabled {
    cursor: not-allowed;

    ${(props) => props.image &&
    css `
        opacity: ${CMP_OPACITY_UI_AVATAR_IMAGE_DISABLED};
      `}
  }
`;
export const StyledImage = styled.img `
  width: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=index.styles.js.map